export default [
  {
    path: "/home", //首页
    name: "home", //首页
    component: (resolve) => require(["@/views/home/home"], resolve),
    hidden: true,
    meta: {
      title: "首页",
      code: "home",
    },
    children: [
      {
        path: "worktable", //工作台
        name: "worktable", //工作台
        component: (resolve) =>
          require(["@/views/worktable/worktable"], resolve),
        meta: {
          title: "工作台",
          code: "worktable",
        },
      },
      {
        path: "ledger_list", //台账表单
        name: "ledger_list", //台账表单
        component: (resolve) =>
          require(["@/views/ledger_list/ledger_list"], resolve),
        meta: {
          title: "台账表单",
          code: "ledger_list",
        },
      },
      {
        path: "file_management", //文件管理
        name: "file_management", //文件管理
        component: (resolve) =>
          require(["@/views/file_management/file_management"], resolve),
        meta: {
          title: "文件管理",
          code: "file_management",
          keepAlive: true,
        },
      },
      {
        path: "file_detail_list", //文件管理
        name: "file_detail_list", //文件管理
        component: (resolve) =>
          require(["@/views/file_management/file_detail_list"], resolve),
        meta: {
          title: "文件列表",
          code: "file_detail_list",
        },
      },
      {
        path: "circulation_personnel", //传阅人员 列表
        name: "circulation_personnel", //传阅人员 列表
        component: (resolve) =>
          require(["@/views/worktable/circulation_personnel"], resolve),
        meta: {
          title: "传阅人员列表",
          code: "circulation_personnel",
        },
      },
      {
        path: "add_file", //文件接收
        name: "add_file", //文件接收
        component: (resolve) =>
          require(["@/views/file_management/add_file"], resolve),
        meta: {
          title: "添加文件",
          code: "add_file",
          keepAlive: true,
        },
      },
      {
        path: "document_handling", //文件承办
        name: "document_handling", //文件承办
        component: (resolve) =>
          require(["@/views/document_handling/document_handling"], resolve),
        meta: {
          title: "文件承办",
          code: "document_handling",
        },
      },
      {
        path: "handling_details", //上传文件承办
        name: "handling_details", //上传文件承办
        component: (resolve) =>
          require(["@/views/document_handling/handling_details"], resolve),
        meta: {
          title: "上传文件承办",
          code: "handling_details",
          keepAlive: true,
        },
      },
      {
        path: "document_borrowing", //文件借阅
        name: "document_borrowing", //文件借阅
        component: (resolve) =>
          require(["@/views/document_borrowing/document_borrowing"], resolve),
        meta: {
          title: "文件借阅",
          code: "document_borrowing",
          keepAlive: true,
        },
      },
      {
        path: "today_loan", //今日借出
        name: "today_loan", //今日借出
        component: (resolve) =>
          require(["@/views/worktable/today_loan"], resolve),
        meta: {
          title: "今日借出",
          code: "today_loan",
        },
      },
      {
        path: "today_not_paid", //今日未还
        name: "today_not_paid", //今日未还
        component: (resolve) =>
          require(["@/views/worktable/today_not_paid"], resolve),
        meta: {
          title: "今日未还",
          code: "today_not_paid",
        },
      },
      {
        path: "edit_borrowing", //借阅单编辑
        name: "edit_borrowing", //借阅单编辑
        component: (resolve) =>
          require(["@/views/document_borrowing/add_edit_borrowing"], resolve),
        meta: {
          title: "借阅单编辑",
          code: "edit_borrowing",
          keepAlive: true,
        },
      },
      {
        path: "document_return", //文件归还
        name: "document_return", //文件归还
        component: (resolve) =>
          require(["@/views/document_return/document_return"], resolve),
        meta: {
          title: "文件归还",
          code: "document_return",
          keepAlive: true,
        },
      },
      {
        path: "edit_return", //归还单编辑
        name: "edit_return", //归还单编辑
        component: (resolve) =>
          require(["@/views/document_return/add_edit_return"], resolve),
        meta: {
          title: "归还单编辑",
          code: "edit_return",
          keepAlive: true,
        },
      },
      {
        path: "document_inventory", //在位监控
        name: "document_inventory", //在位监控
        component: (resolve) =>
          require(["@/views/document_inventory/document_inventory"], resolve),
        meta: {
          title: "在位监控",
          code: "document_inventory",
        },
      },
      {
        path: "document_outbound", //文件出库
        name: "document_outbound", //文件出库
        component: (resolve) =>
          require(["@/views/document_outbound/document_outbound"], resolve),
        meta: {
          title: "文件出库",
          code: "document_outbound",
          keepAlive: true,
        },
      },
      {
        path: "edit_outbound", //出库单编辑
        name: "edit_outbound", //出库单编辑
        component: (resolve) =>
          require(["@/views/document_outbound/add_edit_outbound"], resolve),
        meta: {
          title: "出库单编辑",
          code: "edit_outbound",
          keepAlive: true,
        },
      },
      {
        path: "cabinet_info", // 柜子控制
        component: (resolve) =>
          require(["@/views/cabinet_info/cabinet_info_list"], resolve),
        meta: {
          title: "柜子管理",
          code: "cabinet_info",
        },
      },
      {
        path: "cabinet_log_alarm", // 柜子日志告警
        component: (resolve) =>
          require(["@/views/cabinet_info/cabinet_log_alarm"], resolve),
        meta: {
          title: "柜子日志告警",
          code: "cabinet_log_alarm",
        },
      },
      {
        path: "file_alarm", // 文件告警
        name: "file_alarm",
        component: (resolve) =>
          require(["@/views/alarm_management/file_alarm"], resolve),
        meta: {
          title: "文件告警",
          code: "file_alarm",
        },
      },
      {
        path: "cabinet_alarm", // 柜子告警
        name: "cabinet_alarm",
        component: (resolve) =>
          require(["@/views/alarm_management/cabinet_alarm"], resolve),
        meta: {
          title: "柜子告警",
          code: "cabinet_alarm",
        },
      },
      {
        path: "file_track", // 管控记录
        component: (resolve) =>
          require(["@/views/file_track/file_track_list"], resolve),
        meta: {
          title: "管控记录",
          code: "file_track",
        },
      },
      {
        path: "control_report", //管控报告
        name: "control_report", //管控报告
        component: (resolve) =>
          require(["@/views/control_report/control_report"], resolve),
        meta: {
          title: "管控报告"
        },
      },
      {
        path: "to_do_list", //待办事项
        name: "to_do_list", //待办事项
        component: (resolve) =>
          require(["@/views/to_do_list/to_do_list"], resolve),
        meta: {
          title: "待办事项",
          code: "to_do_list",
        },
      },
      {
        path: "personnel_management", //用户管理
        name: "personnel_management", //用户管理
        component: (resolve) =>
          require([
            "@/views/personnel_management/personnel_management",
          ], resolve),
        meta: {
          title: "人员管理",
          code: "personnel_management",
        },
      },
      {
        path: "account_management", //账户管理
        name: "account_management", //账户管理
        component: (resolve) =>
          require(["@/views/account_management/account_management"], resolve),
        meta: {
          title: "账户管理",
          code: "account_management",
        },
      },
      {
        path: "user_management", //用户管理
        name: "user_management", //用户管理
        component: (resolve) =>
          require(["@/views/user_management/user_management"], resolve),
        meta: {
          title: "用户管理",
          code: "mgr",
        },
      },
      {
        path: "role_management", //角色管理
        name: "role_management", //角色管理
        component: (resolve) =>
          require(["@/views/role_management/role_management"], resolve),
        meta: {
          title: "角色管理",
          code: "role",
        },
      },
      {
        path: "dept_management", //部门管理
        name: "dept_management", //部门管理
        component: (resolve) =>
          require(["@/views/dept_management/dept_management"], resolve),
        meta: {
          title: "部门管理",
          code: "dept",
        },
      },
      {
        path: "position_management", //职位管理
        name: "position_management", //职位管理
        component: (resolve) =>
          require(["@/views/position_management/position_management"], resolve),
        meta: {
          title: "职位管理",
          code: "SYS_POSITION",
        },
      },
      {
        path: "dict_management", //字典管理
        name: "dict_management", //字典管理
        component: (resolve) =>
          require(["@/views/dict_management/dict_management"], resolve),
        meta: {
          title: "字典管理",
          code: "dict",
        },
      },
      {
        path: "dict_detail", //字典管理
        name: "dict_detail", //字典管理
        component: (resolve) =>
          require(["@/views/dict_management/dict_detail"], resolve),
        meta: {
          title: "字典编辑",
          code: "dict",
        },
      },
      {
        path: "menu_management", //菜单管理
        name: "menu_management", //菜单管理
        component: (resolve) =>
          require(["@/views/menu_management/menu_management"], resolve),
        meta: {
          title: "菜单管理",
          code: "menu",
        },
      },
      {
        path: "secadm_log", // 安全保密管理员日志
        name: "secadm_log", // 安全保密管理员日志
        component: (resolve) =>
          require(["@/views/system_log/system_log"], resolve),
        meta: {
          title: "安全保密管理员日志",
          pageApi: "getSecadmLogs",
        },
      },
      {
        path: "sysadmin_log", // 系统管理员日志
        name: "sysadmin_log", // 系统管理员日志
        component: (resolve) =>
          require(["@/views/system_log/system_log"], resolve),
        meta: {
          title: "系统管理员日志",
          pageApi: "getSysadminLogs",
        },
      },
      {
        path: "audit_log", // 安全审计管理员日志
        name: "audit_log", // 安全审计管理员日志
        component: (resolve) =>
          require(["@/views/system_log/system_log"], resolve),
        meta: {
          title: "安全审计管理员日志",
          pageApi: "getAuditLogs",
        },
      },
      {
        path: "base_log", // 普通用户日志
        name: "base_log", // 普通用户日志
        component: (resolve) =>
          require(["@/views/system_log/system_log"], resolve),
        meta: {
          title: "普通用户日志",
          pageApi: "getUserLogs",
        },
      },
      {
        path: "system_config", // 常规配置
        name: "system_config", // 常规配置
        component: (resolve) =>
          require(["@/views/system_config/system_config"], resolve),
        meta: {
          title: "常规配置",
        },
      },
      {
        path: "login_log", //登录日志
        name: "login_log", //登录日志
        component: (resolve) =>
          require(["@/views/login_log/login_log"], resolve),
        meta: {
          title: "登录日志",
          code: "loginLog",
        },
      },
      {
        path: "business_log", //业务日志
        name: "business_log", //业务日志
        component: (resolve) =>
          require(["@/views/business_log/business_log"], resolve),
        meta: {
          title: "业务日志",
          code: "log",
        },
      },
      {
        path: "notice_management", //通知管理
        name: "notice_management", //通知管理
        component: (resolve) =>
          require(["@/views/notice_management/notice_management"], resolve),
        meta: {
          title: "通知管理",
          code: "notice",
        },
      },
      {
        path: "tenant_management", //租户管理
        name: "tenant_management", //租户管理
        component: (resolve) =>
          require(["@/views/tenant_management/tenant_management"], resolve),
        meta: {
          title: "租户管理",
          code: "tenant_info",
        },
      },
      {
        path: "file_handle", //未完成传阅文件
        name: "file_handle", //未完成传阅文件
        component: (resolve) =>
          require(["@/views/worktable/file_handle"], resolve),
        meta: {
          title: "未完成传阅文件",
          code: "file_handle",
        },
      },
      {
        path: "cir_personnel", //未完成传阅人员
        name: "cir_personnel", //未完成传阅人员
        component: (resolve) =>
          require(["@/views/worktable/cir_personnel"], resolve),
        meta: {
          title: "未完成传阅人员",
          code: "cir_personnel",
        },
      },
      {
        path: "borrowing_out", //借出文件
        name: "borrowing_out", //借出文件
        component: (resolve) =>
          require(["@/views/worktable/borrowing_out"], resolve),
        meta: {
          title: "借出文件",
          code: "borrowing_out",
        },
      }
    ],
  },
  {
    path: "/changePassword", // 修改密码
    name: "changePassword", //  修改密码
    component: (resolve) => require(["@/views/login/changePassword"], resolve),
    hidden: true,
  },
];



// WEBPACK FOOTER //
// ./src/router/module/file_mgr_system.js